export function isJquery(element) {
    return !!window.jQuery && element instanceof window.jQuery;
}
